import { getCalendarButtonThemeConfig } from './Calendar/theme.config';
import { getIconButtonThemeConfig } from './Icon/theme.config';
import { getPrimaryButtonThemeConfig } from './Primary/theme.config';
import { getProfileButtonThemeConfig } from './Profile/theme.config';

export const getButtonTheme = () => {
  return {
    iconButton: getIconButtonThemeConfig(),
    primaryButton: getPrimaryButtonThemeConfig(),
    calendarButton: getCalendarButtonThemeConfig(),
    profileButton: getProfileButtonThemeConfig(),
  };
};

export type ButtonTheme = ReturnType<typeof getButtonTheme>;
